<template>
  <el-dialog
    v-if="DialogVisible"
    :title="l('批量上传现货出售')"
    :visible.sync="DialogVisible"
    width="600px"
    class="large-padding-dialog"
    :close-on-click-modal="false"
    :before-close="Hide"
  >
    <!--当用户通过点击关闭图标或遮罩关闭 Dialog 时触发 before-close 对应方法-->
    <el-form
      :model="DialogFormData"
      ref="DialogFormData"
      :rules="dialogRules"
      label-position="left"
      label-width="0"
    >
      <div style="margin-bottom: 15px">
        1. {{l("下载EXCEL模板，并填写商品信息")}}
        <span
          class="ViewLink"
          style="margin-left: 10px"
          @click="downloadTemplate"
          >{{l("点击此处下载模板")}}</span
        >
      </div>
      <div style="margin-bottom: 15px">
        2. {{l("上传填写完毕的EXCEL文件，点击提交")}}
      </div>

      <ResourceUpLoad
        style="display: inline-block"
        prop="file_url"
        usage="website_config"
        file_type="document"
        :initResourceUrl.sync="DialogFormData.file_url"
        :disabled="Type == 'View'"
      />
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="Hide">{{l("取 消")}}</el-button>
      <el-button type="primary" @click="submitForm">{{l("提 交")}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import dialogMixin from "@/assets/js/dialogMixin";

export default {
  name: "CreateOrEditMarketPrice",
  mixins: [dialogMixin],
  data() {
    return {
      DialogFormData: {
        file_url: "",
      },
      dialogRules: {
        file_url: [{ required: true, message: this.l("请上传文件"), trigger: "blur" }],
      },
    };
  },
  methods: {
    submitForm() {
      this.$refs["DialogFormData"].validate((valid, obj) => {
        if (!valid) {
          return this.$message.error(obj[Object.keys(obj)[0]][0].message);
        }

        this.axios
          .post(`/api/seller_quotation/import_bulk_excel/`, this.DialogFormData)
          .then((data) => {
            this.$emit("submitDialog");
            this.Hide();
          });
      });
    },
    downloadTemplate() {
      window.open(
        "https://oss.chinaduancai.com/import_quotation_template.xlsx"
      );
    },
  },
};
</script>


<style scoped lang="scss">
</style>

